import {IRecommendationShort} from "../../../services/models/recommendation";
import s from "./recommendation.module.css";
import sButtons from "../../../assets/styles/buttons.module.css";
import React from "react";

interface RecommendationSectorCardProps {
    recommendation: IRecommendationShort,
    handleLinkClick: (id: string) => void,
}

const RecommendationSectorCard = ({recommendation, handleLinkClick}: RecommendationSectorCardProps) => {

    return (
        <div className={`d-flex flex-column ${s.wrapper}`}>
            <div className={s.content}>
                <div className={s.header}>
                    <div className={s.infoBlock}>
                        <div className={s.roleWrapper}>
                            {recommendation?.statusesCount &&
                                recommendation.statusesCount?.map((status) => (
                                    <p key={status.status} className={s.role}>
                                        {status.status}: {status.count}
                                    </p>
                                ))}
                        </div>

                    </div>
                </div>
                <h3 className={s.title}>{recommendation.name}</h3>
            </div>

            <div className={s.buttons}>
                <button
                    onClick={() => handleLinkClick(recommendation.id)}
                    className={`${sButtons.iconButton} ${s.button} ${sButtons.redirectButtonRight}`}
                >
                    {recommendation.unreadCommentsCount !== 0 && (
                        <span className={s.unreadCount}>{recommendation.unreadCommentsCount}</span>
                    )}
                    <span>Перейти</span>
                </button>
            </div>

        </div>
    );
}

export default RecommendationSectorCard